function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import { default as ModalWrapper } from '@mui/material/Modal';
import _merge from 'lodash/merge';
import { DismissIcon } from "../../images/icons/DismissIcon.js";
import { Box } from "../Box/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { color } from "../../utils/index.js";
import { Typography } from "../Typography/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
export var Popup = function Popup(_ref) {
  var isOpen = _ref.isOpen,
    children = _ref.children,
    _onClose = _ref.onClose,
    testId = _ref.testId,
    showCloseIcon = _ref.showCloseIcon,
    headerTitle = _ref.headerTitle,
    displayHeader = _ref.displayHeader,
    width = _ref.width,
    height = _ref.height,
    disableEscapeKeyDown = _ref.disableEscapeKeyDown,
    disableBackdropClick = _ref.disableBackdropClick,
    disableScrollLock = _ref.disableScrollLock;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  useEffect(function () {
    setOpen(isOpen);
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalWrapper, {
    open: open,
    onClose: function onClose(_, reason) {
      if (disableBackdropClick && reason === 'backdropClick') return;
      if (disableEscapeKeyDown && reason === 'escapeKeyDown') return;
      setOpen(false);
      _onClose === null || _onClose === void 0 ? void 0 : _onClose();
    },
    "data-testid": testId,
    disableAutoFocus: true,
    className: "__ds__comp",
    disableScrollLock: disableScrollLock
  }, /*#__PURE__*/React.createElement("div", {
    style: _merge({
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: height || 'auto',
      width: width || '92%',
      borderRadius: '12px',
      backgroundColor: color(COLOR_VARIANTS.WHITE),
      overflow: 'hidden'
    })
  }, showCloseIcon && !displayHeader && /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      width: 'auto',
      position: 'relative',
      flexDirection: 'row-reverse',
      cursor: 'pointer',
      margin: '16px'
    }
  }, /*#__PURE__*/React.createElement(DismissIcon, {
    onClick: function onClick() {
      setOpen(false);
      _onClose === null || _onClose === void 0 ? void 0 : _onClose();
    },
    width: "24",
    height: "24"
  })), displayHeader && /*#__PURE__*/React.createElement("div", {
    style: _merge({
      backgroundColor: color(COLOR_VARIANTS.WHITE),
      padding: '18px 24px',
      display: 'flex',
      justifyContent: 'space-between'
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.HEADING2,
    color: COLOR_VARIANTS.MINESHAFT,
    component: "p"
  }, headerTitle)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      width: 'auto',
      position: 'relative',
      flexDirection: 'row-reverse',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(DismissIcon, {
    onClick: function onClick() {
      setOpen(false);
      _onClose === null || _onClose === void 0 ? void 0 : _onClose();
    },
    width: "24",
    height: "24"
  }))), children && children)));
};